import React from "react";

type UseControlledStateReturn<T> = [
  T | undefined,
  ((value: T) => void) | undefined
];

export default function useControlledState<T>(
  value?: T,
  onChange?: (value: T) => void
): UseControlledStateReturn<T> {
  const [internalValue, setInternalValue] = React.useState<T | undefined>(
    value
  );

  const initialValueRef = React.useRef(value);

  React.useEffect(() => {
    if (initialValueRef === undefined && value !== undefined) {
      console.warn(
        "A component is changing an uncontrolled input to be controlled"
      );
    }
  }, [value]);

  if (value === undefined) {
    return [internalValue, setInternalValue];
  }

  return [value, onChange];
}
